<template>
    <slot :loading="loading" :packs="packs" :selectedPack="selectedPack" :handlePackChange="handlePackChange" :close="close" :bookNow="bookNow" :showPrices="showPrices"></slot>
</template>

<script>
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';

import eventBus from './utils/event-bus';

export default defineComponent({
    name: 'SeriesPopup',
    props: {
    },
    setup(props) {
        const loading = ref(true);
        const dialog = ref(null);
        const packs = ref(null);
        const selectedPack = ref(null);

        const open = () => {
            eventBus.emit('pricesPopup:close');
            dialog.value.showModal();
        }

        const close = () => {
            dialog.value.close();
        }

        const bookNow = () => {
            eventBus.emit('bookNow');
        }

        const showPrices = () => {
            eventBus.emit('pricesPopup:open');
        }

        const handlePackChange = pack => {
            selectedPack.value = pack;
            eventBus.emit('packChanged', pack);

            if (!window.matchMedia('(max-width: 49.99em)').matches) {
                eventBus.emit('packsPopup:close');
            }
        }

        const setPacks = value => {
            packs.value = value;
        }

        onMounted(() => {
            dialog.value = document.querySelector('#series-package-popup');

            eventBus.on('seriesPacks', setPacks);
            eventBus.on('packsPopup:open', open);
            eventBus.on('packsPopup:close', close);

            loading.value = false;
        });

        onBeforeUnmount(() => {
            eventBus.off('seriesPacks', setPacks);
            eventBus.off('packsPopup:open', open);
            eventBus.off('packsPopup:close', close);
        });

        return {
            loading,
            packs,
            selectedPack,
            handlePackChange,
            close,
            bookNow,
            showPrices,
        }
    },
});
</script>
